export default import.meta.ROLLDOWN_FILE_URL_02cIsRpskrhgAZO9K3KKmw